import {
    Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/cos';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async auth(params: any) {
        return api.auth(params);
    }

    @Action
    async sts(params: any) {
        return api.sts(params)
    }

    @Action
    async getImage(params: any) {
        return api.getImage(params)
    }
}
